import styled from 'styled-components';

import { fadeIn } from '../../../styles/shared.style';
import * as SharedStyles from '../header.shared.styles';

const BaseContainer = styled.section`
  display: flex;
  flex-wrap: wrap;
  width: 100vw;
  max-width: 1192px;
  align-items: center;
  justify-content: space-between;
  padding-top: 16px;
  background-color: ${({ theme }) => theme.colors.surface.high};

  animation: ease-out, ${fadeIn} 0.2s ease-out;

  @media (max-width: 1200px) {
    position: fixed;
    top: 44px;
    left: 0;
    z-index: 20;
    padding: 16px;
  }
`;

export const Container = styled(BaseContainer)<{ $hasEventSection?: boolean }>`
  @media (min-width: 1201px) {
    padding-bottom: ${({ $hasEventSection }) => $hasEventSection ? '0' : '16px'};
  }
`;

export const BreadcrumbSection = SharedStyles.BreadcrumbsContainer;

export const BreadcrumbContent = styled.section`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const BreadcrumbActive = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 14.52px;
  color: ${({ theme }) => theme.colors.accent.primary};
`;

export const BreadcrumbSeparator = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 14.52px;
  color: ${({ theme }) => theme.colors.text.secondary};
  padding: 0 8px;
`;

export const BreadcrumbInactive = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 14.52px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const EventSection = styled.section`
  position: relative;
  display: flex;
  width: 100%;
  max-width: 787px;
  align-items: flex-start;
  gap: 24px;
  padding: 16px;

  @media (max-width: 1200px) {
    padding-top: 0;
  }
`;

export const CardImage = styled.aside`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: auto;
`;

export const PosterImage = styled.img`
  width: 76px;
  height: 76px;
  border-radius: 8px;
  box-sizing: border-box;
  object-fit: cover;
`;

export const EventDetails = styled.aside`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  max-width: 787px;
  gap: 8px;
  margin-left: 24px;

  @media (max-width: 1200px) {
    margin-left: 0;
    padding-top: 16px;
  }
`;

export const EventTitle = styled.h1`
  margin: 0;
  font-family: 'Elza', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 22.4px;
  text-align: left;
`;

export const EventLocation = styled.h2`
  font-family: 'Elza', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  text-align: left;
  margin: 0;
`;

export const Info = styled.section`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
`;

export const Icon = styled.img`
  width: 16px;
  height: 16px;
`;

export const RowFullWidth = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: -2.5px;
  gap: 8px;

  @media (max-width: 1200px) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 16px;
  }
`;

export const ActionLink = styled.span`
  padding: 0;
  margin: 0;
  font-family: 'Elza', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 14.52px;
  text-align: center;
  color: ${({ theme }) => theme.colors.accent.primary};
  cursor: pointer;
`;

export const Wrapper = styled.section`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;
`;

export const ContainerOptions = SharedStyles.OptionsContainer;

export const LocaleSelector = SharedStyles.LocaleContainer;
